import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const element = document.getElementById(hash.substring(1));
      if (element) {
        // Calculate the position of the element relative to the document
        const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
        // Get the height of the fixed navbar (adjust this value as needed)
        const navbarHeight = 80; // Assuming navbar height is around 80px (md:h-20)
        const offsetPosition = elementPosition - navbarHeight;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}

export default ScrollToTop;